import { Filter } from "~/modules/filters/types";
import { isAndOrOperator } from "./functions/isAndOrOperator";

// // // //

export function sortFilters(filters: Filter[]): Filter[] {
    filters.sort((a, b) => {
        if (!isAndOrOperator(a.operator) && isAndOrOperator(b.operator)) {
            return -1; // a should come before b
        } else if (
            isAndOrOperator(a.operator) &&
            !isAndOrOperator(b.operator)
        ) {
            return 1; // a should come after b
        } else {
            return 0; // no sorting needed for these two items
        }
    });

    return filters;
}
